/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_SetsInputs */

const en_us2_plan_sets = /** @type {(inputs: Plan_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 set`);
	return /** @type {LocalizedString} */ (`${i?.count} sets`)
	
};

const pt_br2_plan_sets = /** @type {(inputs: Plan_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série`);
	return /** @type {LocalizedString} */ (`${i?.count} séries`)
	
};

const es_419_plan_sets = /** @type {(inputs: Plan_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 serie`);
	return /** @type {LocalizedString} */ (`${i?.count} series`)
	
};

const pt_pt2_plan_sets = /** @type {(inputs: Plan_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série`);
	return /** @type {LocalizedString} */ (`${i?.count} séries`)
	
};

const fr_fr2_plan_sets = /** @type {(inputs: Plan_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série`);
	return /** @type {LocalizedString} */ (`${i?.count} séries`)
	
};

const de_de2_plan_sets = /** @type {(inputs: Plan_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Satz`);
	return /** @type {LocalizedString} */ (`${i?.count} Sätze`)
	
};

const it_it2_plan_sets = /** @type {(inputs: Plan_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 serie`);
	return /** @type {LocalizedString} */ (`${i?.count} serie`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 set" |
* | * | "{count} sets" |
*
* @param {Plan_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_sets = /** @type {((inputs: Plan_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_sets(inputs)
	if (locale === "es-419") return es_419_plan_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_sets(inputs)
	if (locale === "de-DE") return de_de2_plan_sets(inputs)
	if (locale === "it-IT") return it_it2_plan_sets(inputs)
	return en_us2_plan_sets(inputs)
});
export { plan_sets as "plan.sets" }